import { combineReducers } from "redux";
import propertydocument from "../features/admin/shortlistedproperty/propertydocument/Slice";
import resellproperty from "../features/admin/shortlistedproperty/resellproperty/Slice";
import legalverification from "../features/admin/shortlistedproperty/legalverification/Slice";





const shortlistedproperty = combineReducers({
   propertydocument: propertydocument,
  resellproperty:resellproperty,
  legalverification: legalverification,
  });
  
  export default shortlistedproperty;